import styled, { css } from "styled-components";
import { color, typeStyle, variant } from "@m/alchemy-theme";
import { rgba } from "polished";
import { FocusList } from "../utilities/focus-list/FocusList";
export const TabWrapper = styled.div `
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom-width: 1px;
  border-style: solid;
  ${(props) => css `
    border-color: ${props.activeColorScheme === "alchemyBrand" ? rgba(color("inverse")(props), 0.2) : color("line")};
  `};
  ${typeStyle("bodyM")};
  line-height: 1;
`;
export const TabFocusList = styled(FocusList) `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;

  ${variant("layout", {
    distributed: "justify-content: center;",
    distributedRight: "justify-content: flex-end;",
    distributedLeft: "justify-content: flex-start;",
    left: "justify-content: flex-start;",
    center: "justify-content: center;",
    right: "justify-content: flex-end;"
})};
`;
